var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagretPnc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88854 7.88281C7.59125 8.17855 7.42342 8.58015 7.42188 8.99948C7.42188 9.41941 7.58869 9.82213 7.88562 10.1191C8.18255 10.416 8.58528 10.5828 9.00521 10.5828C9.42454 10.5813 9.82614 10.4134 10.1219 10.1161",
    stroke: "url(#paint0_linear_218_11485)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.25C8.06054 4.25 7.14218 4.52858 6.36104 5.05052C5.57991 5.57246 4.97109 6.3143 4.61157 7.18225C4.25206 8.0502 4.15799 9.00527 4.34127 9.92668C4.52455 10.8481 4.97695 11.6945 5.64125 12.3588C6.30554 13.0231 7.15191 13.4755 8.07332 13.6587C8.99473 13.842 9.9498 13.7479 10.8177 13.3884C11.6857 13.0289 12.4275 12.4201 12.9495 11.639C13.4714 10.8578 13.75 9.93946 13.75 9",
    stroke: "url(#paint1_linear_218_11485)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00261 1.08203C7.43684 1.08203 5.90623 1.54634 4.60434 2.41623C3.30245 3.28612 2.28776 4.52254 1.68856 5.96912C1.08937 7.4157 0.932591 9.00748 1.23806 10.5432C1.54352 12.0788 2.29751 13.4895 3.40468 14.5966C4.51184 15.7038 5.92246 16.4578 7.45814 16.7632C8.99383 17.0687 10.5856 16.9119 12.0322 16.3127C13.4788 15.7136 14.7152 14.6989 15.5851 13.397C16.455 12.0951 16.9193 10.5645 16.9193 8.9987M11.9401 6.06203L9.79427 8.20703",
    stroke: "url(#paint2_linear_218_11485)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4556 3.86735L13.7556 4.24735L14.1356 1.54735C14.1383 1.51599 14.1317 1.48451 14.1165 1.45693C14.1013 1.42936 14.0783 1.40694 14.0503 1.39253C14.0223 1.37813 13.9906 1.37241 13.9593 1.37608C13.9281 1.37976 13.8986 1.39268 13.8747 1.41319L12.0847 3.19402C11.9009 3.3792 11.7656 3.60696 11.691 3.85702C11.6165 4.10709 11.6048 4.37171 11.6572 4.62735L11.9422 6.06069L13.3756 6.34485C13.6312 6.39723 13.8958 6.38561 14.1459 6.31102C14.3959 6.23644 14.6237 6.10121 14.8089 5.91735L16.5889 4.12819C16.6095 4.10424 16.6224 4.0747 16.6261 4.04334C16.6297 4.01198 16.6239 3.98024 16.6094 3.9522C16.5949 3.92416 16.5724 3.9011 16.5446 3.88599C16.5169 3.87087 16.4853 3.86438 16.4539 3.86735",
    stroke: "url(#paint3_linear_218_11485)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_218_11485",
    x1: 8.77187,
    y1: 7.88281,
    x2: 8.77187,
    y2: 10.5828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_218_11485",
    x1: 9,
    y1: 4.25,
    x2: 9,
    y2: 13.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_218_11485",
    x1: 9.00261,
    y1: 1.08203,
    x2: 9.00261,
    y2: 16.9154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_218_11485",
    x1: 14.1261,
    y1: 1.375,
    x2: 14.1261,
    y2: 6.37707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagretPnc);
export default __webpack_public_path__ + "static/media/tagretPnc.e7c1f8c9caee7ddd1425682439ceb449.svg";
export { ForwardRef as ReactComponent };